<div
  id="roleManagementPage"
  *appHasPermission="{
    permissions: [permissions.allPermissions.ROLE_READ],
  }"
>
  <div class="widget">
    @if (timeOut()) {
      <app-timeout></app-timeout>
    } @else if (loading()) {
      <div class="flex h-full justify-content-center align-items-center">
        <p-progressSpinner ariaLabel="loading" class="customProgressSpinner" />
      </div>
    } @else {
      <div class="list-compact-rows">
        <div class="flex justify-content-between align-items-center">
          <span class="listTitle">
            {{ "role_management.list_title" | translate }}
          </span>
          <app-svg-icon
            (click)="onRoleAdd()"
            iconName="plus"
            iconColor="primary"
            class="pointer"
            iconSize="xs"
            *appHasPermission="{
              permissions: [permissions.allPermissions.ROLE_CREATE],
            }"
          >
          </app-svg-icon>
        </div>
        <ngx-simplebar [options]="{ autoHide: false }" class="listItems">
          @for (role of roles(); track role.id) {
            <div class="listRow">
              <span>{{ (role.label ? role.label : "") | translate }}</span>
              <div class="actionButtonGroup">
                <app-svg-icon
                  (click)="onRoleEdit(role)"
                  iconName="edit"
                  iconColor="primary"
                  class="pointer"
                  iconSize="xs"
                  *appHasPermission="{
                    permissions: [permissions.allPermissions.ROLE_UPDATE],
                  }"
                >
                </app-svg-icon>
              </div>
            </div>
          }
        </ngx-simplebar>
      </div>
    }
  </div>
</div>
